import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  usePageMeta({
    title: "Página não encontrada | Atacado Óptico",
    description: "A página que você procura não existe. Volte ao catálogo e encontre os melhores produtos ópticos.",
    robots: "noindex",
  });

  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-muted px-4">
      <div className="text-center max-w-md">
        <p className="text-8xl font-bold text-accent mb-2">404</p>
        <h1 className="text-2xl font-bold text-foreground mb-3">Página não encontrada</h1>
        <p className="text-muted-foreground mb-8">
          O endereço que você acessou não existe ou foi movido. Veja nosso catálogo completo de produtos ópticos.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="bg-accent hover:bg-accent/90 text-white gap-2 w-full sm:w-auto">
              <Home className="h-4 w-4" aria-hidden="true" />
              Ir para a Home
            </Button>
          </Link>
          <Link to="/catalogo">
            <Button variant="outline" className="gap-2 w-full sm:w-auto">
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
              Ver Catálogo
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
